import { useMemo } from 'react';

import { useIntl } from 'react-intl';

import cookieStorage from 'helpers/cookieStorage';
import {
  FLASH_SALE_TRIAL_DAYS,
  isFlashSaleActive,
} from 'helpers/flashSale';
import { findCampaignTrialDays } from 'helpers/pricingPages';
import { getUtmParamsFromCookie } from 'helpers/utm';

import useDefaultTrialDays from './useTrialDays';

const getCrossTeamCampaignTrial = () => {
  const utmParamsFromCookie = getUtmParamsFromCookie();

  return (
    findCampaignTrialDays(utmParamsFromCookie?.utm_campaign) ||
    findCampaignTrialDays(utmParamsFromCookie?.b2b_special_plan) ||
    findCampaignTrialDays(utmParamsFromCookie?.cross_team_campaign) ||
    null
  );
};

const useSubscriptionPlans = (): {
  maxTrialDuration: number;
} => {
  const { locale } = useIntl();
  const { defaultTrialDays } = useDefaultTrialDays();

  const maxTrialDuration = useMemo(() => {
    if (isFlashSaleActive(locale)) {
      return FLASH_SALE_TRIAL_DAYS;
    }

    const trialDays =
      cookieStorage.getItem('TRIAL_DAYS') || getCrossTeamCampaignTrial();

    if (trialDays && !isNaN(Number(trialDays))) {
      return Number(trialDays);
    } else {
      return defaultTrialDays;
    }
  }, [defaultTrialDays, locale]);

  return {
    maxTrialDuration,
  };
};

export default useSubscriptionPlans;
